import { render, staticRenderFns } from "./HotelPageFilters.vue?vue&type=template&id=4f1067af&scoped=true&"
import script from "./HotelPageFilters.vue?vue&type=script&lang=ts&"
export * from "./HotelPageFilters.vue?vue&type=script&lang=ts&"
import style0 from "./HotelPageFilters.vue?vue&type=style&index=0&id=4f1067af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1067af",
  null
  
)

export default component.exports